import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getSystemLogs } from '../../../services/services';

export const getSystemLogsData = createAsyncThunk(
	'getSystemLogs',
	async ({ page, limit, search, startDate, endDate } = {}, thunkAPI) => {
		try {
			const response = await getSystemLogs({ page, limit, search, startDate, endDate });
			return response?.data;
		} catch (error) {
			return thunkAPI.rejectWithValue(error.response?.data || error.message);
		}
	},
);

const systemLogsSlice = createSlice({
	name: 'systemLogsSlice',
	initialState: {
		systemlogsData: null,
		isLoading: false,
		isError: null,
	},
	extraReducers: (builder) => {
		builder
			.addCase(getSystemLogsData.pending, (state) => {
				state.isLoading = true;
				state.isError = null;
			})
			.addCase(getSystemLogsData.fulfilled, (state, action) => {
				state.isLoading = false;
				state.systemlogsData = action.payload;
				state.isError = null;
			})
			.addCase(getSystemLogsData.rejected, (state, action) => {
				state.isLoading = false;
				state.systemlogsData = null;
				state.isError = action.payload;
			});
	},
});

export default systemLogsSlice.reducer;
